import React from 'react';
import TextInput from 'src/ui/library/TextInput';
import InputAdornment from '@material-ui/core/InputAdornment';
import NumberMask from './PercentageMask';
import InfoTooltip from 'src/ui/library/ContentParser/controls/Tooltip/InfoTooltip';
import WithHeader from '../../wrappers/WithHeader';

const renderPercentageControl = props => (
  <TextInput
    InputProps={{
      inputComponent: NumberMask,
      endAdornment: <InputAdornment position="start">%</InputAdornment>,
    }}
    {...props}
  />
);

const PercentageControl = props => {
  const { helpText, ...otherProps } = props;

  let component = renderPercentageControl(otherProps);

  if (helpText) {
    component = <InfoTooltip toolTipText={helpText} labelText={component} className="percentage-tooltip" />;
  }

  return component;
};

export default WithHeader(PercentageControl);
